export const parseSearchParams = (searchParams: string) => {
  try {
    return JSON.parse(searchParams);
  } catch (_err) {
    return {};
  }
};
